// extracted by mini-css-extract-plugin
export default {"main":"layout_main__LKPzP","main_container":"layout_main_container__lEWm5"};